import { http } from '@/plugins/http';

import type { LtiRegistrationSummary } from './state';

export default {
  async fetchActiveRegistrations(): Promise<LtiRegistrationSummary[]> {
    return http.fetch<LtiRegistrationSummary[]>('lti/registrations');
  },
};
